import { Skeleton } from '@/components/core/skeleton';
import { cn } from '@/lib/utils';

export const ContentfulLayoutSkeleton: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        'bg-primary-midnight flex h-full min-h-screen w-full flex-col items-center justify-center space-y-3',
        className
      )}
    >
      <Skeleton className="h-[200px] w-3/4 rounded-xl" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    </div>
  );
};
